module.exports = __webpack_public_path__ + "static/img/1000元代金券.ae8721a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/market/market105/1000元代金券.png
// module id = e1Eu
// module chunks = 1